
export default {
    name: 'IconSalesAgent',
    props: {
        width: {
            type: String,
            default: '24.445px'
        },
        height: {
            type: String,
            default: '24.445px'
        },
        color: {
            type: String,
            default: '#303030'
        }
    }
}
